import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

/** The current employee's own employee-identification status (mirrors the server EmployeeIdentificationStatus). */
export interface EmployeeIdentificationStatus {
  enabled: boolean;
  hasPin: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UserHttpService {

  constructor(private httpClient: HttpClient, @Inject("BASE_URL") private baseUrl: string) {

  }

  ChangePassword(old: string, password: string) {
    return this.httpClient.put(this.baseUrl + "/auth/User/ChangePassword", {
      "OldPassword": old,
      "NewPassword": password
    });
  }

  /** Whether the current employee is enabled for employee identification and whether they already have a PIN. */
  GetIdentificationStatus(): Observable<EmployeeIdentificationStatus> {
    return this.httpClient.get<EmployeeIdentificationStatus>(this.baseUrl + "/auth/employee/identification-status");
  }

  /**
   * Set or change the current employee's own 6-digit critical-step-up PIN. The current PIN is required only when one
   * already exists; the new PIN must be six digits and not trivially weak (validated server-side). The PIN is only
   * ever transmitted to be hashed server-side; it is never stored client-side.
   */
  SetOwnPin(currentPin: string | null, newPin: string): Observable<void> {
    return this.httpClient.put<void>(this.baseUrl + "/auth/employee/pin", {
      "CurrentPin": currentPin && currentPin.length > 0 ? currentPin : null,
      "NewPin": newPin
    });
  }
}
